export const isEqualOrAbove = (current, other) => current >= other;

export const isAbove = (current, other) => current > other;
